module.exports = __webpack_public_path__ + "static/img/re_docspace.66343a72.png";